module.exports = __webpack_public_path__ + "static/img/3-3.14a57956.jpeg";